import * as React from 'react';
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock, Modal } from 'react-bootstrap'
import { IListItem, IXmTracking } from '@nkr/models/index';

interface IProps {
    show: boolean,
    data: IXmTracking,
    cancelReasons: IListItem[],
    onSubmit: (cancelReason: number) => void,
    onCancel: () => void
}

const ConfirmCancel = (props: IProps) => {
    const [cancelReason, setCancelReason] = React.useState(-1);
    const [valid, setValid] = React.useState(true);
    const [dirty, setDirty] = React.useState(false);

    const handleChangeReason = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        setCancelReason(parseInt(e.currentTarget.value));
    };

    const handleSubmit = () => {
        if (cancelReason > 0) {
            props.onSubmit(cancelReason);
        } else {
            setValid(false);
            setDirty(true);
        }
    }

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Confirm XM Request Cancellation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup validationState={dirty && !valid ? 'error' : null}>
                    <ControlLabel>Why is it being cancelled?</ControlLabel>
                    <FormControl
                        componentClass='select'
                        onChange={handleChangeReason}
                    >
                        <option value={-1}>- Select -</option>
                        {props.cancelReasons.map(reason =>
                            <option key={'cr-' + reason.id} value={reason.id}>{reason.description}</option>
                        )}
                    </FormControl>
                    {dirty && !valid && (
                        <HelpBlock>This is required to cancel a request</HelpBlock>
                    )}
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit}>Submit</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmCancel;